<template>
  <div v-if="bol" class="trialApplication_all">
    <div class="all-wrapper">
      <!-- 轮播图和商品信息 -->
      <!-- 试用申请信息 -->
      <div class="trialApplication_header">
        <goodsInfo :goodsParams="goodsImgs" :swiperArr="swiperArr" :point="true" :state="true" @goBack="goBack" btnStyle="width:100%;height:100px;"></goodsInfo>
        <!-- <span>商品列表</span> -->
      </div>
      <div class="trial-message-all">
        <div class="trial-message-header">
          <div class="trial-price">
            <p class="zero"><span><span>¥</span>0</span>免费试</p>
            <s>¥{{ this.trialMessage.goodsPrice ? this.trialMessage.goodsPrice : 0 }} 参考价</s>
          </div>
          <div class="trial-total">
            <p class="total">共{{ this.trialMessage.grantSum }}份</p>
            <p class="people-total">{{ this.trialMessage.applyNum }}人申请</p>
          </div>
        </div>
        <div class="time-message">
          <p class="good-name">{{ this.trialMessage.goodsName }}</p>
          <p class="time">申请时间：{{ this.trialMessage.startTime }} — {{ this.trialMessage.endTime }}</p>
        </div>
      </div>
    </div>
    <div class="apple-fix">
      <div v-if="!this.show" class="apply-btn-true">
        <div class="btn-time">
          <p class="end-time">距申请结束时间</p>
          <p class="count-down">{{ this.countDownTime }}</p>
        </div>
        <button class="applyCase" @click="goToApplyCase">免费申请</button>
      </div>
      <div v-if="this.show" class="apply-btn">
        <button @click="goSignIn">签到赢概率</button>
        <button @click="shareGoods">转发给朋友</button>
      </div>
    </div>

    <audioShare ref="share"></audioShare>
  </div>
</template>
<script src="">
import {getCookie, isUserLogin} from "@/assets/js/common.js";
import goodsInfo from '@/components/contents/trialProductsList/goodsInfo.vue'
import audioShare from "@/components/comment/share.vue";
import API from '@/utils/axiosApi/zeroShoppingApi.js'
import {freetrialClick, freetrialView} from "@/utils/freetrialClick.js"

export default {
  components: {goodsInfo, audioShare},
  name: "trialApplication",
  data() {
    return {
      goodsImgs: {}, // 商品信息
      swiperArr: [], // 轮播数组
      userInfo: {}, // 用户信息
      show: '', // 是否申请通过
      countDownTime: '', // 倒计时时间
      trialMessage: {},// 商品申请信息
      id: 1,
      showEndTime: 1, // 倒计时结束的时间戳
      crmId: '',
      bol: false //接口有返回值 开始渲染页面
    };
  },
  mounted() {
    if (!isUserLogin()) {
      this.crmId = JSON.parse(localStorage.getItem("userInfo")).crm_id

      this.judgeUserIsApply(this.$route.query.id)
      this.id = this.$route.query.id

      this.getTrialShopDetail(this.$route.query.id)
      this.initPage()
      freetrialView({xmhh5_Freetrial_pageview: "试用详情"})
    } else {
      this.$router.push("/home")
    }
  },
  methods: {
    judgeUserIsApply(id) {
      this.$http.post(
          "/trial/apply/judgeUserIsApply",
          {},
          {
            crmId: this.crmId,
            id: id,
          },
          (res) => {
            this.bol = true
            if (res.code === 200) {
              this.show = res.data
            } else {
              this.show = false
            }
          }, (err) => {
            console.log(err)
          },
          "lucky"
      );
    },
    goBack() {
      if (window.history.length > 1 && getCookie("fromPath")) {
        this.$router.go(-1);
      } else {
        // this.$router.push({ path: "/trialProducts" });
        this.$router.replace("/trialProducts");
      }
    },
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    },
    // 获取0元试用商品详情接口
    getTrialShopDetail(id) {
      API.getTrialShopDetail({id}, (res) => {
        console.log(33334444, res, res.data)
        if (res.code === 200) {
          let {
            id,
            goodsName,
            productId,
            skuId,
            goodsPrice,
            grantSum,
            applyNum,
            startTime,
            endTime,
            goodsUrlList,
            goodsUrl
          } = res.data

          //当前时间
          let newDate = Date.parse(new Date());
          //倒计时结束时间
          let disposeEndTime = this.disposeTime(endTime)

          this.showEndTime = Date.parse(new Date(disposeEndTime));
          let time = this.showEndTime - newDate
          // this.showEndTime = 1669598716000
          if (newDate >= this.showEndTime) {
            this.checkTime()
            return
          }
          this.timer(time)

          this.swiperArr = goodsUrlList
          this.goodsImgs.img = goodsUrl
          this.goodsImgs.title = goodsName
          this.goodsImgs.productId = productId
          this.goodsImgs.skuId = skuId
          this.goodsImgs.id = id
          // localStorage.setItem("trial_endTime", endTime)
          console.log(111111111)
          startTime = this.deleteSecond(startTime)
          endTime = this.deleteSecond(endTime)
          this.trialMessage = {goodsPrice, grantSum, goodsName, applyNum, startTime, endTime}
          this.sharePage()
          this.goodData = res.data
        } else if (res.code === 1004) {
          this.checkTime()
        }
      })
    },
    // 转发
    shareGoods() {
      console.log('去转发')
      freetrialClick({xmhh5_Freetrial_pageclick: '试用申请-转发给朋友'})
      this.$refs.share.showShareVideo();
    },
    // 去申请
    goToApplyCase() {
      let newDate = Date.parse(new Date());
      // this.showEndTime = 1669598716000
      if (newDate >= this.showEndTime) {
        this.checkTime()
        return
      }
      localStorage.setItem("updatePage", 1)
      freetrialClick({xmhh5_Freetrial_pageclick: '试用申请-免费申请'})
      this.$router.push({path: "/applyCase", query: {id: this.id,title: this.goodsImgs.title, img:this.goodsImgs.img}});

    },
    // 去签到
    goSignIn() {
      console.log('去签到')
      freetrialClick({xmhh5_Freetrial_pageclick: '试用申请-签到提概率'})
      setTimeout(() => {
        location.href=location.origin + '/member/mine/newPoint?source=xmhH5&redirect=' + encodeURIComponent(window.location.href)
      })
    },
    // 倒计时
    timer(showTime) {
      this.countDownTime = this.getCountDown(showTime)
      let timer = setInterval(() => {
        showTime -= 1000;
        this.countDownTime = this.getCountDown(showTime)
        // console.log(showTime,123123211,this.countDownTime)
        if (showTime <= 0) {
          // 倒计时结束，清除定时器
          window.clearInterval(timer);
        }
      }, 1000)
    },
    //js获取 倒计时 天时分秒
    getCountDown(time) {
      let dec = time / 1000;
      if (dec <= 0) {
        dec = 0;
      }
      // 得到天 格式化成前缀加零的样式
      let d = Math.trunc(dec / 3600 / 24);
      d = d < 10 ? '0' + d : d;
      // 得到小时 格式化成前缀加零的样式
      let h = Math.trunc(dec % (24 * 3600) / 3600);
      h = h < 10 ? '0' + h : h;
      // 得到分钟 格式化成前缀加零的样式
      let m = Math.trunc(dec % 3600 / 60);
      m = m < 10 ? '0' + m : m;
      // 得到秒 格式化成前缀加零的样式
      let s = Math.trunc(dec % 3600 % 60);
      s = s < 10 ? '0' + s : s;
      // 两种返回结果
      return d > 0 ? `${d}天${h}:${m}:${s}` : `${h}:${m}:${s}`
    },
    // 去掉时间中的秒
    deleteSecond(time) {
      let Newtime = time.split(':')
      Newtime.splice(Newtime.length - 1, 1)
      Newtime = Newtime.join(':')
      return Newtime
    },
    // 处理日期格式 兼容苹果手机
    disposeTime(time) {
      let Newtime = time.split('.')
      Newtime = Newtime.join('/')
      return Newtime
    },
    //分享内容
    sharePage() {
      const shareDataParams = {
        shareLink: location.href.split("#")[0],
        shareDesc: '限时免费申请，已有' + this.trialMessage.applyNum + '人申请免费试用，快来看看~',
        shareTitle: this.trialMessage.goodsName,
        imgUrl: this.swiperArr[0],
        // imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
      };
      console.log(shareDataParams.shareDesc, '文案描述111')
      this.wxJsSet.wxShare("fx", shareDataParams, this);
    },
    checkTime() {
      this.$toast({message: '活动结束'});
      setTimeout(() => {
        // this.$router.push({ path: "/trialProducts" });
        this.$router.replace("/trialProducts");
      }, 1000);
    }
  },
};
</script>

<style lang="less" scoped>
.trialApplication_all {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 0 -5px;
  background: #F8F8F8;
  font-family: PingFangSC-Semibold, PingFang SC;
  display: flex;
  flex-direction: column;

  .all-wrapper {
    flex: 1;
    overflow: auto;
    flex-shrink: 0;
    flex-basis: 0;
  }

  //.apple-fix{}
  .trialApplication_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    //height: 505px !important;
    font-size: 14px;
    font-weight: 500;
    /deep/.tagWrap{
      height: 100px;
    }
  }

  .trial-message-all {
    height: 148px;
    margin: 6px 12px 60px 12px;
    background: #FFFFFF;

    .trial-message-header {
      // height: 85px;
      margin-top: 6px;
      display: flex;
      justify-content: space-between;

      .trial-price {
        .zero {
          padding-top: 6px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #FF0000;
          font-weight: 600;
          font-size: 16px;
          margin-left: 6px;

          span {
            font-size: 32px;
            line-height: 40px;
            margin-right: 5px;
            font-family: FeiHeShuZiTi;

            span {
              font-size: 16px;
              margin-right: 2px;
            }
          }
        }

        s {
          color: #999999;
          font-weight: 600;
          font-size: 15px;
          margin-left: 7px;
        }
      }

      .trial-total {
        display: flex;
        justify-content: center;
        align-items: center;

        .total {
          margin-right: 7px;
          font-size: 13px;
          font-weight: 500;
          color: #FF0000;
          line-height: 18.5px;
          font-family: PingFangSC-Medium, PingFang SC;
        }

        .people-total {
          margin-right: 7px;
          font-size: 13px;
          color: #999999;
          line-height: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
        }
      }
    }

    .time-message {
      margin-left: 6px;
      margin-top: 12px;

      .good-name {
        font-size: 17px;
        color: #333333;
        line-height: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
      }

      .time {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 5px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }

  .apply-btn {
    width: 375px;
    height: 65px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-around;

    button {
      width: 163px;
      height: 45px;
      background: #FC656F;
      border-radius: 25px;
      border-style: none;
      font-size: 18px;
      color: #FFFFFF;
    }
  }

  .apply-btn-true {
    width: 375px;
    height: 65px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    position: relative;

    .btn-time {
      padding-left: 18px;

      p {
        height: 22px;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
      }
    }

    .count-down {
      font-size: 15px;
      height: 21px;
      line-height: 21px;
    }

    button {
      width: 120px;
      height: 45px;
      background: #FC656F;
      position: absolute;
      right: 12px;
      border-radius: 25px;
      border-style: none;
      font-size: 18px;
      color: #FFFFFF;
    }
  }
}
</style>
